export enum AnalyticOriginEnum {
    MOBILE = "MOBILE",
    WEB = "WEB",
    ADMIN = "ADMIN",
}
